import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useFormContext } from "react-hook-form";

import { useGetUserRoles } from "api/queries/user/useGetUserRoles";
import LoadingSkeleton from "components/atoms/LoadingSkeleton/LoadingSkeleton";
import DownloadTemplateFilter from "./DownloadTemplateFilter";

const userRoleDataSelector = (data: any) =>
  data.results.map((item: any) => ({
    ...item,
    label: item.name,
    value: item.id,
  }));

function DownloadTemplateRoleFilter() {
  const { data: userRolesData, isLoading }: any = useGetUserRoles({
    refetchOnMount: false,
    select: userRoleDataSelector,
  });
  const { setValue } = useFormContext();

  useEffect(() => {
    if (userRolesData?.length) {
      setValue(
        "selected_user_roles",
        userRolesData.map((item: any) => item.value),
      );
    }
  }, [userRolesData]);

  return (
    <div className="d-flex flex-wrap">
      <div className="mb-xs-3 mb-sm-3 download-user-filter-title">
        <div className="mb-1">
          <h6>
            <FormattedMessage id="settings.fileImportTools.userRole" defaultMessage="User Role" />
          </h6>
        </div>
        <div className="font-b3 text-secondary">
          <FormattedMessage id="settings.fileImportTools.chooseUserRole" defaultMessage="Choose user role" />
        </div>
      </div>

      {!userRolesData?.length && isLoading && (
        <div className="mt-1" style={{ width: 300 }}>
          <LoadingSkeleton rows={2} />
        </div>
      )}
      {!!userRolesData?.length && !isLoading && (
        <DownloadTemplateFilter name="selected_user_roles" options={userRolesData} />
      )}
    </div>
  );
}

export default DownloadTemplateRoleFilter;
